import {Component, EventEmitter, Input, OnInit, Output, ViewChild,} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {isEmpty} from '../../../../../../utils/is-empty';
import {icons} from 'src/app/ui/icons';
import {AddDialogMandataireComponent} from '../add-dialog-mandataire/add-dialog-mandataire.component';
import {EditDialogMandataireComponent} from '../edit-dialog-mandataire/edit-dialog-mandataire.component';
import {DetailMandataireComponent} from '../detail-mandataire/detail-mandataire.component';
import {AppTranslateService} from '../../../../../../modules/services/translate/app-translate.service';
import {ConfirmDialogService} from '../../../../../../modules/services/ui/confirm-dialog.service';

type Column = keyof any;

@Component({
    selector: 'app-mandataire-table',
    templateUrl: './mandataire-table.component.html',
    styleUrls: ['./mandataire-table.component.css'],
})
export class MandataireTableComponent implements OnInit {
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @Input() isetrang = true;
    @Output() next = new EventEmitter<any>();
    tableForm: FormGroup;
    displayedColumns: Column[] = [
        /*  "indRegNo",*/

        'staffNm',
        /*    "telNo",
        "faxNo",
        "issuedYmd",
        "mtelNo",*/
        'positionNm',
        /*    "email",*/
    ];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    labels: Partial<Record<Column, string>> = {
        indRegNo: 'N° de CIN',
        staffNm: 'Nom et prénom',
        telNo: 'N° de téléphone fixe',
        faxNo: 'N° de fax',
        issuedYmd: 'Date de délivrance',
        mtelNo: 'N° de tel portable',
        positionNm: 'Fonction',
        email: 'email',
    };
    displayedColumnss: (Column | 'action' | 'N')[] = [
        'N',
        ...this.displayedColumns,

        'action',
    ];

    icons = icons;

    Ussine: any[] = [];

    constructor(
        private dialog: MatDialog,
        private formBuilder: FormBuilder,
        private appTranslateService: AppTranslateService,
        private confirm: ConfirmDialogService
    ) {
    }

    ngOnInit(): void {
        this.tableForm = this.formBuilder.group({
            listUmRcvAttorney: this.formBuilder.array([]),
        });
    }

    add() {
        const dialogRef = this.dialog.open(AddDialogMandataireComponent, {
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            data: this.isetrang,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (!isEmpty(result)) {
                const isexist = this.dataSource.data.find((x) => {
                    return x.indRegNo == result.data.indRegNo;
                });
                if (isexist) {
                    this.confirm.error('cin_exist');
                } else {
                    this.Ussine.push(result.data);

                    this.dataSource.data = this.Ussine;

                    const listUmRcvAttorney = this.tableForm.get(
                        'listUmRcvAttorney'
                    ) as FormArray;
                    listUmRcvAttorney.push(
                        this.formBuilder.group({
                            indRegNo: [result.data.indRegNo],
                            staffNm: [result.data.staffNm],
                            telNo: [result.data.telNo],
                            faxNo: [result.data.faxNo],
                            mtelNo: [result.data.mtelNo],
                            email: [result.data.email],
                            positionNm: [result.data.positionNm],
                            issuedYmd: [result.data.issuedYmd],
                        })
                    );
                }
            }
            this.table.renderRows();
        });
    }

    removeCart(index: number, data: any) {
        this.Ussine.splice(index, 1);
        this.dataSource.data = this.Ussine;

        const userCtrl = this.tableForm.get('listUmRcvAttorney') as FormArray;

        userCtrl.removeAt(index);
    }

    addf() {
        const f = this.tableForm.value;
        this.next.emit(f);
    }

    edit(data, index) {
        data.etranger = this.isetrang;
        const dialogRef = this.dialog.open(EditDialogMandataireComponent, {
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            width: '70vw',
            data: data,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (!isEmpty(result)) {
                const isexist = this.dataSource.data.find((x, i) => {
                    return x.indRegNo == result.data.indRegNo && i != index;
                });
                if (isexist) {
                    this.confirm.error('cin_exist');
                } else {
                    const t = this.Ussine[index];
                    t.indRegNo = result.data.indRegNo;
                    t.staffNm = result.data.staffNm;
                    (t.telNo = result.data.telNo),
                        (t.faxNo = result.data.faxNo),
                        (t.mtelNo = result.data.mtelNo),
                        (t.email = result.data.email),
                        (t.positionNm = result.data.positionNm),
                        (t.issuedYmd = result.data.issuedYmd),
                        (this.dataSource.data = this.Ussine);

                    const listUmRcvAttorney = this.tableForm.get(
                        'listUmRcvAttorney'
                    ) as FormArray;

                    const ta = listUmRcvAttorney.at(index);
                    ta.patchValue({
                        indRegNo: result.data.indRegNo,
                        staffNm: result.data.staffNm,
                        telNo: result.data.telNo,
                        faxNo: result.data.faxNo,
                        mtelNo: result.data.mtelNo,
                        email: result.data.email,
                        positionNm: result.data.positionNm,
                        issuedYmd: result.data.issuedYmd,
                    });
                }
            }
            this.table.renderRows();
        });
    }

    open(element: any) {
        const dialogRef = this.dialog.open(DetailMandataireComponent, {
            disableClose: true,
            data: element,
            direction: this.appTranslateService.getDir(),
        });
    }
}
